export function computeLayout(participants = [], { screenShareId = null, spotlightId = null, pinnedId = null } = {}) {
   const byId = new Map(participants.map(p => [p.id, p]));
   const mainParticipant =
      (pinnedId && byId.get(pinnedId)) ||
      (screenShareId && byId.get(screenShareId)) ||
      (spotlightId && byId.get(spotlightId)) ||
      null;
      
   const others = participants.filter(p => p.id !== mainParticipant?.id);
   return { primary: mainParticipant, others };
}
